import { createMuiTheme } from "@material-ui/core";

const theme = createMuiTheme({
  typography: {
    fontFamily: ["Inter", "Pyidaungsu"].join(","),
  },
});
export default theme;
